<!-- ==========================================================================
     FLUJOS
     ========================================================================== -->

<div class="container-fluid flows-page">

  <div class="flows-container">

    <!-- ======================================================================
         01. HEADER PRINCIPAL
         ====================================================================== -->

    <div class="flows-header">

      <div class="flows-header-main">

        <div class="flows-header-icon">
          <i class="fa-solid fa-code-branch"></i>
        </div>

        <div class="flows-header-content">

          <span class="flows-eyebrow">
            CONFIGURACIÓN
          </span>

          <h4>
            Flujos
          </h4>

          <p>
            Administra los flujos configurados para este servicio.
          </p>

        </div>

      </div>


      <!-- AGREGAR -->

      <button type="button" class="flows-add-button" (click)="openModal(createUser, 'add', 'Agregar Flujo')">

        <i class="fa-solid fa-plus"></i>

        <span>
          Agregar flujo
        </span>

      </button>

    </div>


    <!-- ======================================================================
         02. RESUMEN
         ====================================================================== -->

    <div class="flows-info">

      <div class="flows-info-main">

        <div class="flows-info-icon">
          <i class="fa-solid fa-diagram-project"></i>
        </div>

        <div class="flows-info-text">

          <strong>
            Flujos configurados
          </strong>

          <span>
            Gestiona los flujos disponibles y sus configuraciones.
          </span>

        </div>

      </div>


      <!-- CONTADOR -->

      <div class="flows-counter">

        <span class="flows-counter-value">
          {{ totalItems || 0 }}
        </span>

        <span class="flows-counter-label">
          {{ totalItems === 1 ? 'flujo' : 'flujos' }}
        </span>

      </div>

    </div>


    <!-- ======================================================================
         03. LISTADO
         ====================================================================== -->

    <div class="flows-list-section">

      <div class="flows-list-header">

        <div>

          <h5>
            Flujos disponibles
          </h5>

          <p>
            Consulta y administra los flujos registrados.
          </p>

        </div>

      </div>


      <!-- TABLA -->

      <div class="flows-table-wrapper">

        <app-paginacion [currentPage]="currentPage" [totalItems]="totalItems" [selectedPageSize]="pageSize"
          [paginatedData]="currentItems" [headers]="tableHeaders" [actions]="customActions"
          (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" [loading]="spinner">
        </app-paginacion>

      </div>

    </div>

  </div>

</div>


<!-- ==========================================================================
     MODAL AGREGAR / EDITAR FLUJO
     ========================================================================== -->

<ng-template #createUser let-modal>

  <div class="flow-modal">

    <!-- ======================================================================
         04. HEADER MODAL
         ====================================================================== -->

    <div class="flow-modal-header">

      <div class="flow-modal-title">

        <div class="flow-modal-icon">

          <i class="fa-solid" [ngClass]="idBucketP ? 'fa-pen-to-square' : 'fa-plus'">
          </i>

        </div>


        <div class="flow-modal-title-content">

          <span class="flow-modal-eyebrow">
            FLUJO
          </span>

          <h4>
            {{ title }}
          </h4>

          <p>
            Configura la información correspondiente al flujo.
          </p>

        </div>

      </div>


      <!-- CERRAR -->

      <button type="button" class="flow-modal-close" aria-label="Cerrar" (click)="modal.dismiss('Cross click')">

        <i class="fa-solid fa-xmark"></i>

      </button>

    </div>


    <!-- ======================================================================
         05. BODY MODAL
         ====================================================================== -->

    <div class="flow-modal-body">

      <app-flujo [idBucketP]="idBucketP" [idBucketDefault]="defaultBucket" (saved)="saved($event)" (close)="closeModal()">
      </app-flujo>

    </div>

  </div>

</ng-template>